// src/pages/Contact.js
import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';



const Edit = ({ edit, toggle_Edit, invoiceId, refreshData, AddcurrentPage  }) => {
  const [selectedDates, setSelectedDates] = useState('');
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const [formData, setFormData] = useState({
    id: '',
    // message: '',
    mode: '',
    openingBalance: '',
    amount: '',
    closingBalance: '',
    utr: '',
    orderId: '',
    refId: '',
    userId: {
      id: ''
    },
    date: '',
    // recorn: '',
    // refund: '',
    service: '',
    customerName: '',
    cardNumber: '',
    time: ''

  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle input changes
  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: { id: value } });
  }; 

   //*********************************** Fetch invoice data when the modal opens ********************************************************
   const token = authServices.getToken();
   useEffect(() => {
    
    const fetchInvoiceData = async () => {
      if (edit && invoiceId) {
        loader('enable');
        
        try {
          const response = await apiClient.get(`/api/admin/transaction/${invoiceId}`, {
          
                  headers: {
                    'access_token': token,
                  },
          
                });
          
          if(response.data.Status === "SUCCESS") {
        
          setFormData({
            id: invoiceId || '',
            // message: response.data.data.message || '',
            mode: response.data.data.mode || '',
            openingBal: response.data.data.openingBal || "0.00",
            amount: response.data.data.amount || '',
            closingBal: response.data.data.closingBal || '',
            utr: response.data.data.utr || '',
            orderId: response.data.data.orderId || '',
            refId: response.data.data.refId || '',

            userId:{id : response?.data?.data?.userId?.id || '' },
            date: response.data.data.date || '',
            // recorn: response.data.data.recorn || '',
            // refund: response.data.data.refund || '',
            service: response.data.data.service || '',
            customerName: response.data.data.customerName || '',
            cardNumber: response.data.data.cardNumber || '',
            time: response.data.data.time || '',
          });
          }
            else{
              console.log(response.data.message)
            }
        } catch (error) {
          console.error('catch Error :- ', error.response ? error.response.data.message : error);
        } finally {
          loader('disable');
        }
      }
    };
  
    fetchInvoiceData();
  }, [invoiceId, edit]);  


  //******************************************* Handle save and update the data **************************************************
  const handleSave = async () => {
    loader('enable');
  
    try {
      const response = await apiClient.put(`/api/admin/transaction/update`, formData, {
      
              headers: {
                'access_token': token,
              },      
            });
      if(response.data.Status === "SUCCESS") {
        
      }
        else{
          console.log(response.data.message)
        }  
    }
    catch (error) {
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      toggle_Edit();
      loader('disable');
    }
  };
  
  return (
    <>
      {edit && (
        <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalScrollableTitle">
                  Edit Transaction
                </h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle_Edit} >
                  < RxCross2 />
                </button>
              </div>
              <div className="modal-body-custom">
                <form>

                <div className='row w-100'>
                  {/* <div className="spacing w-50 d-inline-block">
                    <label htmlFor="message" className="label-custom">Message</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    />
                  </div> */}

                  <div className="spacing w-100 d-inline-block">
                    <label htmlFor="mode" className="label-custom">Mode</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="mode"
                      name="mode"
                      value={formData.mode}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="openingBal" className="label-custom">Opening Balance</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="openingBal"
                      name="openingBal"
                      value={formData.openingBal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="amount" className="label-custom">Amount</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="amount"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="closingBal" className="label-custom">Closing Balance</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="closingBal"
                      name="closingBal"
                      value={formData.closingBal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="utr" className="label-custom">UTR</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="utr"
                      name="utr"
                      value={formData.utr}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="orderId" className="label-custom">Order ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="orderId"
                      name="orderId"
                      value={formData.orderId}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="refId" className="label-custom">Reference ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="refId"
                      name="refId"
                      value={formData.refId}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="userId" className="label-custom">User ID</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="userId"
                      name="userId"
                      value={formData.userId.id}
                      onChange={handleChange2}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="date" className="label-custom">Date</label>
                    <input
                      type="date"
                      className="input-custom"
                      id="date"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  {/* <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="recorn" className="label-custom">Recorn</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="recorn"
                      name="recorn"
                      value={formData.recorn}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="refund" className="label-custom">Refund</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="refund"
                      name="refund"
                      value={formData.refund}
                      onChange={handleChange}
                    />
                  </div>
                  </div> */}

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="service" className="label-custom">Service</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block">
                    <label htmlFor="customerName" className="label-custom">Customer Name</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="customerName"
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                  <div className='row w-100'>
                  <div className="spacing w-50 d-inline-block" style={{width:"34.20vw"}}>
                    <label htmlFor="cardNumber" className="label-custom">Card Number</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="cardNumber"
                      name="cardNumber"
                      value={formData.cardNumber}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="spacing w-50 d-inline-block" style={{width:"34.20vw"}}>
                    <label htmlFor="time" className="label-custom">Time</label>
                    <input
                      type="text"
                      className="input-custom"
                      id="time"
                      name="time"
                      value={formData.time}
                      onChange={handleChange}
                    />
                  </div>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={toggle_Edit}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave}>
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Edit;
